import { render, staticRenderFns } from "./IDate.vue?vue&type=template&id=45fe523a&"
import script from "./IDate.vue?vue&type=script&lang=js&"
export * from "./IDate.vue?vue&type=script&lang=js&"
import style0 from "./IDate.vue?vue&type=style&index=0&id=45fe523a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports